import React from 'react'
import SideNav from './SideNav'

const Careers = () => {
  return (
    <div>
      <>
        <div className="page-header-carrers parallaxie">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-header-box">
                  <h1 className="text-anime-style-2" data-cursor="-opaque">
                    Careers
                  </h1>
                  <div className="hero-btn wow fadeInUp" data-wow-delay="0.4s">
                    <a href="about-us" className="btn-default">About Us</a>
                    <a href="contact-us" className="btn-default btn-highlighted">Contact Us</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-service-single">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="service-single-content">

                  

                  <div className="service-entry">
                    <p className="wow fadeInUp">
                      At <b>MeHome</b>, we believe great spaces are created by great people. 
                      For over a decade and a half, our team has been designing, constructing, 
                      and styling environments that inspire. If you’re passionate about creativity, 
                      innovation, and craftsmanship — join our growing family.
                    </p>

                    <h2 className="text-anime-style-2" data-cursor="-opaque">
                      Why <span>Work With Us</span>
                    </h2>
                    <ul>
                      <li>Creative freedom to explore design ideas and experiment fearlessly.</li>
                      <li>Collaborative work culture that values diversity and respect.</li>
                      <li>Career growth through training, mentorship, and skill development.</li>
                      <li>Opportunity to work on premium interior and construction projects.</li>
                      <li>Exposure to every phase — from concept to execution and delivery.</li>
                    </ul>
                  </div>

                  <div className="why-choose-content service-single-why-choose">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Current <span>Openings</span>
                      </h2>
                    </div>

                    <div className="why-choose-item-list">
                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.3s">
                        <div className="icon-box">🎨</div>
                        <div className="why-choose-item-content">
                          <h3>Interior Designers</h3>
                          <p>
                            Conceptualize, visualize, and execute creative interiors for homes and commercial spaces.  
                            <br /><b>Experience:</b> 2–6 years | <b>Skills:</b> AutoCAD, SketchUp, 3D Max
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.5s">
                        <div className="icon-box">🏗️</div>
                        <div className="why-choose-item-content">
                          <h3>Project Engineers / Site Supervisors</h3>
                          <p>
                            Manage on-site activities, vendor coordination, and ensure quality execution.  
                            <br /><b>Experience:</b> 3–8 years | <b>Skills:</b> Site Management, AutoCAD
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.7s">
                        <div className="icon-box">🪑</div>
                        <div className="why-choose-item-content">
                          <h3>Furniture & Modular Designers</h3>
                          <p>
                            Design efficient and stylish modular furniture with practical detailing.  
                            <br /><b>Experience:</b> 2–5 years | <b>Skills:</b> Modular Design, Material Knowledge
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.9s">
                        <div className="icon-box">🌿</div>
                        <div className="why-choose-item-content">
                          <h3>Landscape Architects</h3>
                          <p>
                            Plan and design outdoor spaces that balance beauty and sustainability.  
                            <br /><b>Experience:</b> 3–7 years | <b>Skills:</b> CAD, Horticulture Knowledge
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="1.1s">
                        <div className="icon-box">📑</div>
                        <div className="why-choose-item-content">
                          <h3>Accounts & Admin Executives</h3>
                          <p>
                            Handle billing, documentation, and coordination tasks for smooth operations.  
                            <br /><b>Experience:</b> 1–4 years | <b>Skills:</b> Tally, Excel, Communication
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="service-single-faq">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        How to <span>Apply</span>
                      </h2>
                    </div>
                    <div className="wow fadeInUp" data-wow-delay="0.6s">
                      <p>
                        If you’re ready to design, innovate, and grow — we’d love to hear from you.  
                        Send your updated <b>resume and portfolio</b> to  
                        <a href="mailto:careers@mehome.in" className="text-highlighted"> careers@mehome.co.in</a>
                      </p>
                      <p>
                        You can also visit our Hyderabad office for walk-in discussions during weekdays.  
                        <br /><b>Address:</b> MeHome Interiors & Construction, Hyderabad, India
                      </p>
                    </div>
                  </div>

                </div>
              </div>

              <div className="col-lg-4">
                <SideNav />
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  )
}

export default Careers
